import { LodashHelper } from '.';

import { differenceInHours, parseISO, isBefore, addHours } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { RIDE_STATUSES } from '../constants/constants';

export class RideHelper {
  /**
   * True if step1 has required riderInfo per schema.
   * Used when Step1 reports invalid due to extra API fields; we still enable Save if required fields are present.
   */
  static isStep1RiderInfoComplete(step1) {
    const r = step1?.riderInfo;
    if (!r || typeof r !== 'object') return false;
    const first = String(r.firstName ?? '').trim();
    const last = String(r.lastName ?? '').trim();
    const phone = String(r.phoneNumber ?? '').replace(/\D/g, '');
    const dob = String(r.dob ?? '').trim();
    return first.length > 0 && last.length > 0 && phone.length === 10 && dob.length > 0;
  }

  static compareRideValues(defaultValues, exitingValues) {
    if (!exitingValues) return true;
    const cleanFormikValues = LodashHelper.removeEmpty(exitingValues);
    if (cleanFormikValues?.step1) delete cleanFormikValues.step1.formattedRiderName;
    const cleanDraft = defaultValues ? LodashHelper.removeEmpty(defaultValues) : defaultValues;
    if (cleanDraft?.step1) delete cleanDraft.step1.formattedRiderName;
    return LodashHelper.isEqual(cleanFormikValues, cleanDraft);
  }

  static validateSameDayRoundTrip = (ride) => {

 
    if (!ride?.connectedLeg) {
      return {
        isSameDayRoundTrip: false,
        isLegACompleted: null,
        legA: null,
        legB: null,
      };
    }

    const legA = ride.leg === "A" ? ride : ride.connectedLeg;
    const legB = ride.leg === "B" ? ride : ride.connectedLeg;

    if (!legA.pickUpDate || !legB.pickUpDate) {
      return {
        isSameDayRoundTrip: false,
        isLegACompleted: null,
        legA: null,
        legB: null,
      };
    }

    // Parse pickUpDate to ensure they are valid date objects
    const pickUpDateA = parseISO(legA.pickUpDate.datetime);
    const pickUpDateB = parseISO(legB.pickUpDate.datetime);
   
    // Calculate the difference in hours between the two pickup dates
    const hoursDifference = Math.abs(differenceInHours(pickUpDateA, pickUpDateB));

    // Check if the difference is within 24 hours
    const isSameDayRoundTrip = hoursDifference <= 24;

    // Check if LegA has a status of COMPLETED
    const isLegACompleted = legA.status === "COMPLETED";

    // Return the validation result and the leg objects
    return {
      isSameDayRoundTrip,
      isLegACompleted,
      legA,
      legB,
    };
  }

  static isRideValidForReschedule(ride) {
    if (!ride) {
      return false; // If ride is null or undefined, return false
    }

    if (ride.status !== RIDE_STATUSES.ACCEPTED) {
      return false; // If ride status is not ACCEPTED, return false
    }

     
    if (ride.rescheduledFrom) {
      return false;
    }

    const pickUpDate = utcToZonedTime(parseISO(ride.actualPickUpDate.datetime), ride.actualPickUpDate.timezone); // Convert pickUpDate to the ride's timezone


    if (isNaN(pickUpDate)) {
      return false; // If pickUpDate is invalid, return false
    }


    // Get the current time in the ride's timezone
    const currentTimeInTimezone = utcToZonedTime(new Date(), ride.timezone);

    // Add 48 hours to the current time
    const timeLimit = addHours(currentTimeInTimezone, 48);

    // Log values for debugging


    // Check if the pickUpDate is before the 48-hour limit
    if (isBefore(pickUpDate, timeLimit)) {
      return false;
    }

    // If all checks pass, return true
    return true;
  }
}
